import { Link } from 'react-router-dom';
import '../../../scss/components/BrandMarquee.scss';
import BrandCard from './BannerCard';
import { BrandMarqueeProps } from '../../../interface/interface';

// hover:-translate-y-0.5 hover:scale-[1.02] hover:shadow-md

const BrandMarquee = ({
  title,
  brands,
  viewAllHref,
}: Readonly<BrandMarqueeProps>) => {
  if (!brands.length) return null;

  return (
    <section className="bg-primary-blue-50/30 py-10 md:py-14">
      {(title || viewAllHref) && (
        <div className="container-standard mb-6 flex items-center justify-between md:mb-8">
          {title && (
            <h2 className="text-lg font-semibold text-primary-blue-500 md:text-xl 2xl:text-2xl">
              {title}
            </h2>
          )}
          {viewAllHref && (
            <Link
              to={'/guest/shop-non-script'}
              className="text-xs font-semibold text-primary-blue-500 hover:underline md:text-sm"
            >
              View All Brands &gt;
            </Link>
          )}
        </div>
      )}

      <div className="overflow-hidden motion-reduce:overflow-x-auto">
        <div className="mvr-brand-marquee-track flex w-max gap-5 md:gap-6">
          {brands.map((brand) => (
            <BrandCard key={brand.id} brand={brand} />
          ))}

          {/* Exact duplicate of the row above so the loop has no visible seam.
              `contents` keeps it out of the flex box model (so the gap stays
              uniform across the boundary) while `aria-hidden` keeps it out of
              the accessibility tree. */}
          <div className="contents motion-reduce:hidden" aria-hidden="true">
            {brands.map((brand) => (
              <BrandCard
                key={`${brand.id}-duplicate`}
                brand={brand}
                ariaHidden
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default BrandMarquee;
